import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Register from './components/Register';
import Login from './components/Login';
import Profile from './components/Profile';
import ConfirmAccount from './components/ConfirmAccount';
import Dashboard from './components/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import UserPredictions from './components/UserPredictions';
import ChangePasswordForm from './components/ChangePasswordForm';
import Rules from './components/Rules';
import AdminMatches from './components/AdminMatches'; // 👈 Importamos el panel de admin

function App() {
  return (
    <Router>
      <Navbar />
      {/* Nota: Si notas que el Login o Dashboard se ven raros por el 'container', 
        puedes mover este div dentro de los componentes específicos. 
      */}
      <div className="container mx-auto p-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/confirm" element={<ConfirmAccount />} />
          <Route path="/dashboard" element={<Dashboard />} />
           <Route path="/rules" element={<Rules />} />
          
          {/* RUTA DE TRANSPARENCIA (Ver apuestas de otros) */}
          <Route path="/user-predictions/:userId" element={<UserPredictions />} />

          {/* RUTA DE ADMINISTRACIÓN (Cargar resultados reales) */}
          <Route path="/admin-matches" element={<AdminMatches />} /> {/* 👈 Nueva ruta añadida */}
          
          {/* RUTAS DE RECUPERACIÓN */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* RUTAS DE USUARIO */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePasswordForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;